<ng-container *transloco="let t">
  <div class="pb-200-228 mt-16">
    <div class="content-box">
      <div class="pb-300-100">
        <section class="mb-3">
          <p class="medium pb-2 text-uppercase">
            {{ t('event.info.description') }}
          </p>
          <div class="mb-1">
            <div class="d-inline-flex align-items-center">
              <img src="assets/icons/icons-alt/event_note.svg" alt="">
              <p class="ps-1">{{
                  event && event!.start ? (event!.start | localizedDate:'short')
                    : '-'
                }}</p>
            </div>
          </div>
          @if(event?.description ?? event?.descriptionEng ?? event?.descriptionIta ?? event?.descriptionSlo ?? event?.descriptionSr) {
          <p class="regular">
            <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="event?.description"
                                 [enLabel]="event?.descriptionEng"
                                 [itLabel]="event?.descriptionIta"
                                 [siLabel]="event?.descriptionSlo"
                                 [srLabel]="event?.descriptionSr"
                                 [bsLabel]="event?.descriptionBs"
                                 [defaultLanguage]="event?.defaultLanguage"
                                 [defaultLabel]="t('event.details.empty')" [languages]="languages"/>
          </p>
          }
        </section>
        @if (event?.rules ?? event?.rulesEng ?? event?.rulesIta ?? event?.rulesSlo ?? event?.rulesSr) {
        <section class="mb-3">
          <p class="medium pb-2 text-uppercase">
            {{ t('event.info.rules') }}
          </p>
          <p class="regular">
            <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="event?.rules"
                                 [enLabel]="event?.rulesEng"
                                 [itLabel]="event?.rulesIta" [siLabel]="event?.rulesSlo"
                                 [srLabel]="event?.rulesSr"
                                 [bsLabel]="event?.rulesBs"
                                 [defaultLanguage]="event?.defaultLanguage"
                                 [defaultLabel]="event?.rules ?? event?.rulesEng ?? event?.rulesIta ?? event?.rulesSlo ?? event?.rulesSr ?? ''" [languages]="languages"/>
          </p>
        </section>
        }
<!--        <section class="mb-3">-->
<!--          <p class="medium pb-2 text-uppercase">-->
<!--            {{ t('event.info.prise.fund') }}-->
<!--          </p>-->
<!--          <p class="regular">-->
<!--            <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="event?.awardFund"-->
<!--                                 [enLabel]="event?.awardFundEng"-->
<!--                                 [itLabel]="event?.awardFundIta" [siLabel]="event?.awardFundSlo"-->
<!--                                 [srLabel]="event?.awardFundSr"-->
<!--                                 [defaultLanguage]="event?.defaultLanguage"-->
<!--                                 [defaultLabel]="t('event.awardFund.details.empty')" [languages]="languages"/>-->
<!--          </p>-->
<!--        </section>-->
<!--        <section class="mb-3">-->
<!--          <p class="medium pb-2 text-uppercase">-->
<!--            {{ t('event.info.Gallery') }}-->
<!--          </p>-->
<!--        </section>-->
      </div>
    </div>
  </div>
</ng-container>
